import { DeleteTwoTone, PaperClipOutlined, SearchOutlined } from '@ant-design/icons';
import { AutoComplete, Modal } from 'antd';
import * as mime from 'mime-types';
import moment from 'moment';
import { FunctionComponent, useContext, useEffect, useState } from 'react';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import AppContext from '../../App.context';
import { getAttachmentInvoice, saveInvoice } from '../../api/NetworkingInvoice';
import { LookUpTableDetail } from '../../api/hooks/useLookUpTables';
import useOnlineRights from '../../api/hooks/useOnlineRights';
import { formatDate, formatValidAutocompleteClass, formatValidInputClass } from '../../helpers/FormatHelper';
import { OnlineRightsNames } from '../../helpers/OnlineRightsHelper';
import { getResource } from '../../helpers/ResourcesHelper';
import AttachmentsForm from '../attachments/AttachmentsForm';
import Button from '../inputs/Button';
import DatePicker from '../inputs/DatePicker';
import Dropdown from '../inputs/Dropdown';
import Input from '../inputs/Input';
import ConfirmationModal from '../others/ConfirmationModal';
const dateFormat = 'YYYY/MM/DD';

interface InvoiceAddEditFormDialogProps {
  InvoiceType: string;
  settlementCurrencies: any[];
  onClose: () => void;
  beneficiaries: any[];
  changeState?: Function;
  onLoadInvoices: () => void;
  objInvoice: any;
  StatusList: any[];
  customer: any;
  onLoadInvoicesAddBene: (invoiceID: number, updateToken: string, senderName: string, customerEmail: string) => void
}

const InvoiceAddEditFormReceivable: FunctionComponent<InvoiceAddEditFormDialogProps> = (props) => {
  const { showModal, showLoadingModal, hideLoadingModal } = useContext(AppContext);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState(moment(new Date(), dateFormat).format(dateFormat))
  const [currencyId, setCurrencyId] = useState('');
  const [taxes, setTaxes] = useState(0);
  const [total, setTotal] = useState(0);
  const [senderID, setSenderID] = useState('');
  const [senderName, setSenderName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [invoiceLink, setInvoiceLink] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileContent, setFileContent] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [beneficiaryId, setBeneficiaryId] = useState(0);
  const [beneficiarySearch, setBeneficiarySearch] = useState('');
  const [validations, setValidations] = useState({
    invoiceNumber: true,
    invoiceDate: true,
    currencyId: true,
    taxes: true,
    senderID: true,
    senderName: true,
    terms: true,
    beneficiaryId: true,
    status: true
  });
  const [terms, setTerms] = useState(0);
  const [availableCurrencies, setAvailableCurrencies] = useState([]);
  const [scaleAmount, setScaleAmount] = useState(2);
  const [invoiceID, setInvoiceID] = useState(0);
  const [updateToken, setUpdateToken] = useState('');
  const [status, setStatus] = useState('');

  const [currentFileName, setCurrentFileName] = useState('');
  const [currentFileURLList, setCurrentFileURLList] = useState([]);
  const [showOpenAlert, setShowOpenAlert] = useState(false);
  const [currentBlob, setCurrentBlob] = useState({} as any);
  const [currentExtension, setCurrentExtension] = useState('');
  const [openAttachment, setOpenAttachment] = useState(false);
  const OL_BeneficiaryUser = useOnlineRights(OnlineRightsNames.OL_BeneficiaryUser);
  const [customerName, setCustomerName] = useState('');
  const [openBeneficiaries, setOpenBeneficiaries] = useState(false);
  const [beneficiariesFiltered, setBeneficiariesFiltered] = useState(props.beneficiaries);
  const [canEdit, setCanEdit] = useState(true);
  const [listDetails, setListDetails] = useState([{
    ID: -1,
    key:0,
    Description:'',
    Quantity:0,
    UnitPrice:0,
    Amount:0,
    validDescription:true,
    validQuantity:true,
    validUnitPrice:true
  }])

  useEffect(() => {
    setAvailableCurrencies(props.settlementCurrencies as any);
  }, [props.settlementCurrencies])

  useEffect(() => {
    if (OL_BeneficiaryUser && props.beneficiaries) {
      const userSession = JSON.parse(localStorage.getItem('UserSession')!);
      let objBeneficiary = props.beneficiaries.find(b => b.BeneficiaryID === userSession.BeneficiaryID)
      if (objBeneficiary) {
        handleGetBeneficiary(objBeneficiary);
      }
      setCustomerName(userSession.CustomerName);
    }
  }, [props.beneficiaries, OL_BeneficiaryUser])

  useEffect(() => {
    if (props.objInvoice && props.objInvoice.InvoiceIssuedID > 0) {
      setInvoiceID(props.objInvoice.InvoiceIssuedID);
      setInvoiceNumber(props.objInvoice.InvoiceNumber);
      setInvoiceDate(props.objInvoice.InvoiceDate);
      //setInvoiceDescription(props.objInvoice.InvoiceDescription);
      //setAmount(props.objInvoice.Amount);
      setCurrencyId(props.objInvoice.CurrencyID);
      setTaxes(props.objInvoice.Taxes);
      setTotal(props.objInvoice.Total);
      setSenderID(props.objInvoice.ExternalCustomerID);
      setSenderName(props.objInvoice.ExternalCustomerName);
      setBeneficiarySearch(props.objInvoice.ExternalCustomerName);
      setCustomerEmail(props.objInvoice.Email);
      setInvoiceLink(props.objInvoice.InvoiceLink);
      setFileName(props.objInvoice.FileName);
      setBeneficiaryId(props.objInvoice.BeneficiaryID);
      setStatus(props.objInvoice.Status);
      if ((props.objInvoice.Status !== 'Pending' && props.objInvoice.IsUser) || OL_BeneficiaryUser) {
        setCanEdit(false);
      }
      if(props.objInvoice.detailsJson)
      {

        if(props.objInvoice.detailsJson.length > 0)
        {
          let details = [] as any;
          props.objInvoice.detailsJson.map((item: any, index: number)=>{
            details.push({
              ID: item.ID,
              key: index,
              Description:item.Description,
              Quantity:item.Quantity,
              UnitPrice:item.UnitPrice,
              Amount:item.Amount,
              validDescription:true,
              validQuantity:true,
              validUnitPrice:true
            });
          })
          setListDetails(details);
        }
      }
    }
    else {
      clearData();
    }
  }, [props.objInvoice])

  const onClickExit = () => {
    props.onClose();
  }

  const clearData = () => {
    setInvoiceID(0);
    setInvoiceNumber('');
    setInvoiceDate(moment(new Date(), dateFormat).format(dateFormat));
    setCurrencyId('');
    setTaxes(0);
    setTotal(0);
    setSenderID('');
    setSenderName('');
    setCustomerEmail('');
    setInvoiceLink('');
    setFileName('');
    setFileContent([]);
    setShowUpload(false);
    setBeneficiaryId(0);
    setTerms(0);
    setUpdateToken('');
    setStatus('Pending');
    setValidations({
      invoiceNumber: true,
      invoiceDate: true,
      currencyId: true,
      taxes: true,
      senderID: true,
      senderName: true,
      terms: true,
      beneficiaryId: true,
      status: true
    });
    setShowConfirmation(false);
    if (props.InvoiceType === 'Payable') {
      setAvailableCurrencies([]);
    }
  }

  const handleInvoiceNumber = (event: any) => {
    setInvoiceNumber(event.target.value);
  }

  const handleUpdateInvoiceDate = (date: any) => {
    setInvoiceDate(date);
  }

  const handleInvoiceDescription = (event: any, index: number) => {
    let list = [...listDetails];
    list[index].Description = event.target.value;
    list[index].validDescription = (event.target.value !== '')
    setListDetails(list);

  }

  const handleGetCurrency = (obj: any) => {
    if (obj != null && obj.value != null) {
      setCurrencyId(obj.value);
      setScaleAmount(obj.numberOfDecimals);
    }
  }

  const handleGetBeneficiary = (obj: any) => {
    if (obj != null && obj.value != null) {
      var beneCurrencies = [] as any;
      var currencies = props.settlementCurrencies;
      var auxAvailableCurrencies = [] as any;
      if (obj.Currencies != null && obj.Currencies !== '') {
        beneCurrencies = obj.Currencies.replace('(', '').replace(')', '').split(',');

        currencies.forEach((element: any) => {
          var ccy = beneCurrencies.findIndex((ccy: any) => element.value === ccy);
          if (ccy >= 0) {
            auxAvailableCurrencies.push(element);
          }
        });
      }
      setBeneficiaryId(obj.value)
      setAvailableCurrencies(auxAvailableCurrencies);
    }
  }

  const handleInvoiceAmount = (value: number, index: number) => {
    let list = [...listDetails];
    list[index].Amount = value;
    setListDetails(list);

    let subTotal = 0;
    list.map((i:any) => subTotal+= i.Amount);

    let auxTotal = taxes + subTotal;
    setTotal(auxTotal);
  }

  const handleInvoiceQuantity = (value: number, index: number) => {
    let list = [...listDetails];
    let amount = value*list[index].UnitPrice;
    list[index].Quantity = value;
    list[index].Amount = amount;
    list[index].validQuantity = (value >0);
    setListDetails(list);
  }

  const handleInvoiceUnitPrice = (value: number, index: number) => {
    let list = [...listDetails];
    let amount = value*list[index].Quantity;
    list[index].UnitPrice = value;
    list[index].Amount = amount;
    list[index].validUnitPrice = (value >0);

    setListDetails(list);
  }

  const handleInvoiceTerms = (value: number) => {
    setTerms(value);
  }

  const handleInvoiceTaxes = (value: number) => {
    let list = [...listDetails];
    let subTotal = 0;
    list.map((i:any) => subTotal+= i.Amount);

    let auxTotal = value + subTotal;
    setTaxes(value);
    setTotal(auxTotal);
  }

  const handleSenderID = (event: any) => {
    setSenderID(event.target.value);
  }

  const handleSenderName = (event: any) => {
    setSenderName(event.target.value);
  }

  const handleCustomerEmail = (event: any) => {
    setCustomerEmail(event.target.value);
  }

  const handleInvoiceLink = (event: any) => {
    setInvoiceLink(event.target.value);
  }

  const onAttachmentsClick = () => {
    setShowUpload(true);
  }

  const onCloseAttachmentsForm = () => {
    setShowUpload(false);
  }

  const onUploadFile = (attachmentID: string, filename: string, description: any, fileContent: any) => {
    //(attachmentID, fileName, description) => {
    //console.log('--attachmentID -> ' + { attachmentID } + '--fileName' + fileName + '--description' + description);
    if (attachmentID != null) {
      hideLoadingModal();
      setShowUpload(false);
      setFileName(filename);
      setFileContent(fileContent);
    }
  }

  const handleSaveClick = () => {    
    if (validate()) {
      setShowConfirmation(true);
    } else {
      showModal(getResource('Js_MessageError_TitleError'), getResource('Js_MessageError_FormValidationNFieldNHighlighted'));
    }
  }

  const resetValidations = (validations: any) => {
    validations.invoiceNumber =
      validations.invoiceDate =
      validations.invoiceDescription =
      validations.amount =
      validations.currencyId =
      validations.taxes =
      validations.senderName =
      validations.beneficiaryId =
    validations.senderID =
    validations.status =
      validations.terms = true;
    return validations;
  }

  const validate = () => {
    var result = true;
    var tempValidations = validations;
    tempValidations = resetValidations(tempValidations);

    if (invoiceNumber === null || invoiceNumber === undefined || invoiceNumber === '') {
      result = false;
      tempValidations.invoiceNumber = false;
    }

    if (invoiceDate === null || invoiceDate === undefined || invoiceDate === '') {
      result = false;
      tempValidations.invoiceDate = false;
    }

    if (currencyId === '' || currencyId === 'select') {
      result = false;
      tempValidations.currencyId = false;
    }

    if (taxes === null || taxes === undefined) {
      result = false;
      tempValidations.taxes = false;
    }

    /*
    if (props.InvoiceType === 'Receivable' && (senderID === undefined || senderID === '')) {
      result = false;
      tempValidations.senderID = false;
    }*/

    if (props.InvoiceType === 'Receivable' && (senderName === undefined || senderName === '')) {
      result = false;
      tempValidations.senderName = false;
    }

    if (status === '' || status.includes('Select ')) {
      result = false;
      tempValidations.status = false;
    }

    if (terms === undefined) {
      result = false;
      tempValidations.terms = false;
    }
    setValidations(tempValidations);

    return result;
  }

  const closeAlert = () => {
    setShowConfirmation(false);
  }

  const yesAlert = () => {
    //setState({ showConfirmation: false });
    if(validateDetails())
    {
    showLoadingModal();
    const userSession = JSON.parse(localStorage.getItem('UserSession')!);
    var userID = localStorage.getItem('UserID');
    var customerId = userSession.CustomerID;
    var date = formatDate(invoiceDate);

    let details: any[] = [];
    if(listDetails.length > 0)
    {
      listDetails.map((item,index) =>{
          details.push({
            ID: item.ID,
            LineNumber: index+1,
            Description: item.Description,
            Amount: item.Amount,
            UnitPrice: item.UnitPrice,
            Quantity: item.Quantity
          });
      })
    }
debugger
    let invoice = {
      InvoiceIssuedId: invoiceID,
      CustomerId: customerId,
      InvoiceNumber: invoiceNumber,
      InvoiceDate: date,
      InvoiceDescription: 'Invoice to ' + senderName,
      Amount: total-taxes,
      CurrencyId: currencyId,
      Taxes: taxes,
      Total: total,
      ExternalCustomerID: beneficiaryId,//senderID,
      ExternalCustomerName: senderName,
      ExternalCustomerEmail: customerEmail,
      InvoiceLink: invoiceLink,
      CreatedBy: userID,
      FileName: fileName,
      FileContent: fileContent,
      InvoiceType: props.InvoiceType,
      Terms: terms,
      BeneficiaryID: beneficiaryId,
      Status: status,
      UpdateToken: updateToken,
      detailsJson: details.length === 0 ? '': JSON.stringify(details)
    }

    saveInvoice(invoice).then(
      (response) => {
        if (typeof response !== undefined && response.httpStatusCode === 200) {
          hideLoadingModal();
          if (beneficiaryId === 0) {
            props.onLoadInvoicesAddBene(response.InvoiceID, response.updateToken, senderName, customerEmail);
          }
          else {
          showModal(getResource('Js_MessageError_TitleSuccess'), getResource('Js_Message_SaveSuccessfully'));
          }
          clearData();

          props.onLoadInvoices();
          onClickExit();
        }
        else {
          hideLoadingModal();
          showModal(getResource('Js_MessageError_TitleError'), getResource('Something went wrong. Please try again later.'));
        }
      });
    }
  }

  const statusFilterChangeHandler = (detail: LookUpTableDetail) => {
    if (detail != null) {
      setStatus(detail.value);
    }
  };

  const onCloseViewAttachment = () => {
    setCurrentFileName([] as any);
    setCurrentFileURLList([] as any);
    setOpenAttachment(false);
  }

  const getDate = (dateString: string) => {
    if (dateString === '') {
      return undefined;
    }
    const date = moment(dateString, dateFormat);
    return date && date.isValid() ? date : undefined;
  };

  const onViewAttachment = () => {
    getAttachmentInvoice(invoiceID).then(
      (value) => {
        var byteCharacters = atob(value.data);
        var byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var bytes = new Uint8Array(byteNumbers);
        var blob = new Blob(
          [bytes], {
          type: mime.lookup(File.name) as string
        });
        /*var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = obj.Filename;
        link.click();*/

        var arrayName = fileName.split(".")

        let fileList = [{
          uri: window.URL.createObjectURL(blob),
          fileType: arrayName[arrayName.length - 1].toLowerCase(),
          fileName: fileName
        }] as any;
        if (arrayName.length !== 0) {
          if (arrayName[arrayName.length - 1] === 'xlsx' || arrayName[arrayName.length - 1] === 'xls' ||
            arrayName[arrayName.length - 1] === 'docx' || arrayName[arrayName.length - 1] === 'doc' ||
            arrayName[arrayName.length - 1] === 'docm') {
            setShowOpenAlert(true);
            setCurrentBlob(blob);
            setCurrentFileName(fileName);
            setCurrentExtension(arrayName[arrayName.length - 1]);
          } else {
            setCurrentFileName(File.name);
            setCurrentFileURLList(fileList);
            setOpenAttachment(true);
          }
        }
      });
  }

  const yesDowloadFile = () => {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(currentBlob);
    link.download = currentFileName;
    link.click();
  }

  const disabledDate = (current: any) => {
    let today = moment(new Date());
    return current > today;
  };

  const onSelectBeneficiary = (item: any, option: any) => {
    setBeneficiarySearch(option.BeneficiaryName);
    setSenderName(option.BeneficiaryName);
    setBeneficiaryId(option.value);
    setCustomerEmail(option.BeneficiaryEmail);
    setOpenBeneficiaries(false);

  }

  const onChangeBeneficiary = (data: string, option: any) => {
    setBeneficiarySearch(data);
    setSenderName(data);
    setOpenBeneficiaries(false);
    setBeneficiaryId(0);
    setCustomerEmail('');
    setAvailableCurrencies(props.settlementCurrencies as any);
  };

  const handleSearchBeneficiaries = (value: string) => {
    console.log(beneficiariesFiltered);
  };

  const onSearchBeneficiaries = () => {
    if (props.beneficiaries) {
      let filter = props.beneficiaries.filter(b => b.BeneficiaryName.toLowerCase().includes(beneficiarySearch.toLowerCase()));
      setBeneficiariesFiltered(filter);
      setOpenBeneficiaries(true);
    }
  }

  const AddDetail = () =>{
    if(validateDetails())
    {
      let list = [...listDetails];
      let id = 0;
      if(list.length > 0)
      {
        id = list[list.length-1].key +1;
      }

      list.push({
        ID:-1,
        key:id,
        Description:'',
        Quantity:0,
        UnitPrice:0,
        Amount:0,
        validDescription:true,
        validQuantity:true,
        validUnitPrice:true
      });
      setListDetails(list);
    }
  }

  const validateDetails = () =>{
    let list = [...listDetails];
    let valid = true;
    list.map((item:any) => {
      item.validDescription = (item.Description !== '');
      item.validQuantity = (item.Quantity >0);
      item.validUnitPrice = (item.UnitPrice >0);
     
      if(!item.validDescription || !item.validQuantity || !item.validUnitPrice)
      {
        valid = false;
      }
    })

    setListDetails(list);

    return valid;
  }

  const deleteRow =(id: number) =>{
    let list = [...listDetails];
    list = list.filter((item:any) => item.ID !== id);

    setListDetails(list);
  }

  const getRowDetails = () =>{
    let rows = [] as any;
    listDetails.forEach((d:any, index: number)=>{      
      rows.push(<div className="col-md-12 col-xs-12 row middle-xs start-xs">
        {/* DESCRIPTION */}
        <div className="col-md-6 col-xs-12">
          <div className="row">
            <span className="label-visible">{getResource('Description')}</span>
            <input type="text" name={`f-mbi-invoceDes-${index}`} id={`f-mbi-invoceDes-${index}`}
              maxLength={150} className={formatValidInputClass(d.validDescription,'invoice-input')}
              value={d.Description} onChange={(e) =>handleInvoiceDescription(e,index)}
              placeholder='Enter item name/description'
              
              disabled={!canEdit}
            />
          </div>
        </div>
        {/* QUANTITY */}
        <div className="col-md-1 col-xs-12">
          <div className="row">
            <span className="label-visible">{"Qty"}</span>
            <Input
              type="number"
              name={`f-mbi-invoceQty-${index}`} id={`f-mbi-invoceQty-${index}`}
              className={formatValidInputClass(d.validQuantity,'invoice-input-number')}
              value={d.Quantity}
              onValueChange={(e)=>handleInvoiceQuantity(e,index)}                  
            //onBlur={onBlurAmount}
              placeholder={'0'}
              decimalScale={0}
              disabled={!canEdit}
            />
          </div>
        </div>
        {/* UnitPrice */}
        <div className="col-md-2 col-xs-12">
          <div className="row">
            <span className="label-visible">{"Rate"}</span>
            <Input
              type="number"
              name={`f-mbi-invoceUnitPrice-${index}`} id={`f-mbi-invoceUnitPrice-${index}`}
              className={formatValidInputClass(d.validUnitPrice,'invoice-input-number')}
              value={d.UnitPrice}
              onValueChange={(e) => handleInvoiceUnitPrice(e,index)}                  
            //onBlur={onBlurAmount}
            placeholder={'0.00000'}
              disabled={!canEdit}
            />
          </div>
        </div>
        {/* AMOUNT */}
        <div className="col-md-2 col-xs-12">
          <div className="row">
            <span className="label-visible">{getResource('Amount')}</span>
            <Input
              type="number"
              name={`f-mbi-invoceAmount-${index}`} id={`f-mbi-invoceAmount-${index}`}
              className={'invoice-input-number'}
              value={d.Amount}
              onValueChange={(e)=>handleInvoiceAmount(e,index)}
              decimalScale={scaleAmount}                      
            //onBlur={onBlurAmount}
              placeholder={'0.00000'}
              disabled={true}
            />
          </div>
        </div>
        {canEdit &&
        <div className="col-md-1 col-xs-12">
        <DeleteTwoTone id={`delete-${index}`}  onClick={(e) =>{deleteRow(d.ID)}} twoToneColor={"#34c521"} />
        </div>}
      </div>)
    })

    return rows;
  }

  let city = props.customer.City && props.customer.City !== '' ? `${props.customer.City}, ` : ''
  let zip = props.customer.PostalCode && props.customer.PostalCode !== '' ? `, ${props.customer.PostalCode}` : ''

  return (
    <div>
      <Modal
        title={
          <div className='header-invoice'>
            <div className='company-info'>
              <h3 className="component-title">{props.customer.CustomerName}</h3>
              <div>{props.customer.AddressLine1}</div>
              <div>{`${city}${props.customer.StateName}${zip}`}</div>
              <div>{props.customer.CountryName}</div>
            </div>
            <div>
              <h3 className="component-title">{"Invoice"}
              </h3>
            </div>
          </div>
        }
        centered
        visible={true}
        footer={null}
        //onCancel={props.changeState()}
        maskClosable={false}
        className='invoice-modal'
        zIndex={1000}
        closable={false}
      >
        <div>
          <div>

            <div className="row-invoice">
              <div className="row-invoice cell-invoice">
                  <span className="input-label">{"Bill to:"}</span>

                    {/* CUSTOMER NAME */}
                  <div className="row">
                    <div className="col-md-8 col-xs-12">
                      <AutoComplete
                        allowClear
                        options={beneficiariesFiltered}
                        notFoundContent={getResource('PlaceHolder.NoResults')}
                          placeholder={"Your client's name"}
                        open={openBeneficiaries}
                        onSelect={onSelectBeneficiary}
                        onChange={onChangeBeneficiary}
                        value={beneficiarySearch}
                        onSearch={handleSearchBeneficiaries}
                        className={formatValidAutocompleteClass(validations.beneficiaryId,'invoice-autocomplete')}
                        onBlur={() => setOpenBeneficiaries(false)}
                        disabled={!canEdit}
                        />
                      </div>
                    {canEdit && <div style={{marginLeft:'5px'}}>
                      <Button type="search" onClick={onSearchBeneficiaries}>
                        <SearchOutlined />
                      </Button>
                    </div>}
                  </div>

                    {/* CUSTOMER EMAIL */}     
                  <div className='row'>
                  <div className="col-md-8 col-xs-12">
                      <input type="text" name="f-mbi-invoceemail" id="f-mbi-invoceemail"
                        maxLength={75}
                          placeholder="Client's email"
                        value={customerEmail} onChange={handleCustomerEmail}
                        disabled={beneficiaryId > 0}
                          className='invoice-input'
                      />
                  </div>
                  </div>   
              </div>

              <div className="row-invoice cell-invoice">
                <div className="row">
                  {/* INVOICE NUMBER */}
                      <div className='col-md-4 col-xs-12'>
                      <span className="input-label">{getResource('Label.InvoiceNumber')}</span>
                      </div>
                    <div >
                      <input type="text" name="f-mbi-invoceNumber" id="f-mbi-invoceNumber"
                        maxLength={25} className={formatValidInputClass(validations.invoiceNumber,'invoice-input')}
                        value={invoiceNumber} onChange={handleInvoiceNumber}
                        placeholder={getResource('Label.InvoiceNumber')}
                        disabled={!canEdit}
                      />
                    </div>
                  </div>

                  {/* INVOICE DATE */}

                  <div className="row">
                      <div className='col-md-4 col-xs-12'>
                      <span className="input-label">{getResource('Label.InvoiceDate')}</span>
                      </div>
                      <div>
                      <DatePicker
                        id="f-ph-view-range-show-from"
                        key="f-ph-view-range-show-from"
                        className={formatValidInputClass(validations.invoiceDate,'invoice-input')}
                        onChange={handleUpdateInvoiceDate}
                        value={getDate(invoiceDate)}
                        valueValidation={invoiceDate}
                        disabledDate={disabledDate}
                        disabled={!canEdit}
                      //disabledDays={[0, 6]}
                      //readOnly={true}
                      />
                      </div>
                  </div>

                  {/* TERMS */}
                  <div className="row">
                      <div className='col-md-4 col-xs-12'>
                      <span className="input-label">{getResource('Label.InvoiceTerms')}</span>
                      </div>
                      <div>
                      <Input
                        type="number"
                        className={formatValidInputClass(validations.terms,'invoice-input')}
                        value={terms}
                        onValueChange={handleInvoiceTerms}
                        decimalScale={0}
                        placeholder={getResource('Label.InvoiceTerms')}
                        disabled={!canEdit}
                      //onBlur={onBlurAmount}
                      />
                      </div>
                  </div>
              </div>
            </div>

            
            <div className="row-invoice">
            <div className="row-invoice cell-invoice">
                <div className="row">
                  {/* CURRENCY */}
                      <div className='col-md-4 col-xs-12'>
                      <span className="input-label">{getResource('Label.Currency')}</span>
                      </div>
                    <div >
                    <Dropdown
                        className={formatValidInputClass(validations.currencyId,'invoice-input')}
                        name="f-mbi-invoceCCY"
                        title={getResource('SelectCurrency')}
                        list={availableCurrencies}
                        select={{ value: currencyId }}
                        onChange={handleGetCurrency}
                        disabled={!canEdit}
                      />
                    </div>
                  </div>
            </div>

            <div className="row-invoice cell-invoice">
                <div className="row">
                  {/* STATUS */}
                      <div className='col-md-4 col-xs-12'>
                      <span className="input-label">{getResource('Label.Status')}</span>
                      </div>
                    <div >
                    <Dropdown
                        name="statusReceivable"
                        title={getResource('SelectStatus')}
                        list={props.StatusList}
                        select={{ value: status }}
                        onChange={statusFilterChangeHandler}
                        className={formatValidInputClass(validations.status,'invoice-input')}
                        
                      />
                    </div>
                  </div>
            </div>
            </div>

            <div className="row middle-xs start-xs">
              


              {/* SECTION AMOUNT */}
              <div className="col-md-12 col-xs-12 row middle-xs center-xs">
                {/* DESCRIPTION */}
                <div className="col-md-6 col-xs-12 header-hidden">
                  <label className="input-required">{getResource('Description')}</label>
                </div>
                {/* QUANTITY */}
                <div className="col-md-1 col-xs-12 header-hidden">
                  <label className="input-required">{"Qty"}</label>
                </div>
                {/* UnitPrice */}
                <div className="col-md-2 col-xs-12 header-hidden">
                  <label className="input-required">{"Rate"}</label>
                </div>
                {/* AMOUNT */}
                <div className="col-md-2 col-xs-12 header-hidden">
                  <label className="input-required">{getResource('Amount')}</label>
                </div>
                <div className="col-md-1 col-xs-12 header-hidden"></div>
              </div>
            </div>

            <hr style={{ marginTop: '0px' }}></hr>
            <div className="row middle-xs start-xs">
              {getRowDetails()}
            </div>

            <div className="row middle-xs start-xs">
              {canEdit &&
                <div className="col-md-12 col-xs-12 row middle-xs start-xs">
                  <a id='add-item' className="column-actions" onClick={AddDetail}>Add Line Item
                  </a>
                </div>
              }
            </div>

            <hr></hr>
            <div className="row middle-xs start-xs">
              <div className="col-md-12 col-xs-12 row middle-xs">
                {/* TAXES */}
                <div className="col-md-9 col-xs-12">
                  <div className="row end-xs">
                    <span>{getResource('Label.InvoiceTaxes')}</span>
                  </div>
                </div>
                <div className="col-md-2 col-xs-12">
                  <Input
                    type="number"
                    value={taxes}
                    onValueChange={handleInvoiceTaxes}
                    decimalScale={scaleAmount}
                    className='invoice-input-number'
                  //onBlur={onBlurAmount}
                    placeholder={'0.00000'}
                    disabled={!canEdit}
                  />
                </div>
              </div>

              <div className="col-md-12 col-xs-12 row middle-xs">

                {/* TOTAL */}
                <div className="col-md-9 col-xs-12">
                  <div className="row end-xs">
                    <span>{getResource('Label.InvoiceTotal')}</span>
                  </div>
                </div>
                <div className="col-md-2 col-xs-12">
                  <Input
                    type="number"
                    value={total}
                    //onChange={handleInvoiceTaxes}
                    //onBlur={onBlurAmount}
                    disabled={true}
                    decimalScale={scaleAmount}
                    placeholder={'0.00000'}
                    className='invoice-input-number'
                  />
                </div>
              </div>
            </div>

            <hr></hr>

            <div className="row middle-xs start-xs">
              <div className="col-md-12 col-xs-12 row middle-xs">
                {/* INVOICE LINK */}
                <div className="col-md-2 col-xs-12">
                  <div className="row">
                    <span>{getResource('Label.InvoiceLink')}</span>
                  </div>
                </div>
                <div className="col-md-10 col-xs-12">
                  <input type="text" name="f-mbi-invocelink" id="f-mbi-invocelink"
                    maxLength={150}
                    value={invoiceLink} onChange={handleInvoiceLink}
                    placeholder='Enter invoice link'
                    className='invoice-input'
                    disabled={!canEdit}
                  />
                </div>
              </div>

              <div className="col-md-12 col-xs-12 row middle-xs">
                {/* INVOICE ATTACHMENT */}
                <div className="col-md-2 col-xs-12">
                  <div className="row">
                    <span>{getResource('Label.InvoiceAttachment')}</span>
                  </div>
                </div>
                <div className="col-md-10 col-xs-12">
                  <PaperClipOutlined onClick={onAttachmentsClick} disabled={!canEdit} />
                  <a onClick={onViewAttachment} ><span className="fnt-size-08">{fileName}</span>
                  </a>
                </div>
              </div>
            </div>


            <div className="row-actions">
                  <Button id="exit-button" type="secondary" onClick={onClickExit}>
                    {getResource('Btn_Exit')}
              </Button>
                  <Button id="exit-button" type="primary" onClick={handleSaveClick}>
                    {getResource('Button.Save')}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <ConfirmationModal visible={showConfirmation} cancel={closeAlert} confirm={yesAlert} title={getResource('AreYouSureYouWantToSave')} />
      <AttachmentsForm
        key={'orders-disbursement-attachment-form'}
        id={'orders-disbursement-attachment-form'}
        show={{ id: '', show: showUpload }}
        onClose={onCloseAttachmentsForm}
        useLinkID={false}
        onUploadWithoutLink={onUploadFile}
        showList={false}
      />
      <Modal
        centered
        visible={openAttachment}
        footer={null}
        onCancel={onCloseViewAttachment}
        maskClosable={false}
        className='modal-message'
        zIndex={1010}
        closable={true}
      >
        <div>
          <DocViewer
            pluginRenderers={DocViewerRenderers}
            documents={currentFileURLList}
            config={{
              header: {
                disableHeader: true,
                disableFileName: true,
                retainURLParams: false
              }
            }}
          />
        </div>
      </Modal>
      <ConfirmationModal visible={showOpenAlert} cancel={() => setShowOpenAlert(false)} confirm={yesDowloadFile} title={getResource('NoPreview')} />

    </div>
  );
}
export default InvoiceAddEditFormReceivable;